import React, { useState } from 'react'
import styled from 'styled-components'
import { H, P, BackgroundImageWrapper } from '@farewill/ui'
import {
  COLOR,
  BORDER,
  GTR,
  CONTAINER_PADDING_HORIZONTAL_AT_BP,
} from '@farewill/ui/tokens'
import { screenMin } from '@farewill/ui/helpers/responsive'

import { trackEvent } from 'lib/tracking'

import { QUESTIONS } from './constants'
import Question from './Question'
import Result from './Result'
import { getNotes, calculateEstimates } from './helpers'

const StyledWrapper = styled(BackgroundImageWrapper)`
  background-position: right -${GTR.XL} top 180px;

  ${screenMin.m`
    background-position: right -164px top 100px;
    border-radius: ${BORDER.RADIUS.M};
  `}
`

const Calculator = () => {
  const [answers, setAnswers] = useState([])

  const hasWill = answers[0] === 'yes'

  const addAnswer = (answer) => {
    let path = ''
    if (answers.length === 1 || answers.length === 2)
      path = ` - ${hasWill ? 'will' : 'no will'}`
    let eventLabel = `Question ${answers.length + 1}${path}`

    // product want to be able to see the answer a user has given to the last 2 questions
    if (answers.length >= 7) eventLabel = `${eventLabel}, answer: ${answer}`

    trackEvent('Probate calculator answer', 'click', eventLabel)

    // if the user answers no to the 8th question, we want to skip the 9th
    if (answers.length === 7 && answer.toLowerCase() === 'no')
      return setAnswers([...answers, answer.toLowerCase(), 'skipped'])

    return setAnswers([...answers, answer.toLowerCase()])
  }

  const removeLastAnswer = () => {
    setAnswers(answers.slice(0, -1))
  }

  return (
    <StyledWrapper
      margin={[0, `-${CONTAINER_PADDING_HORIZONTAL_AT_BP.S}`]}
      marginFromM={0}
      padding={['XL', 'M']}
      paddingFromM={['XL', 'L']}
      background={COLOR.ACCENT.PRIMARY}
      imagePath="textures/pattern-1"
      imageWidth={300}
      imageWidthFromM={400}
    >
      <H size="L" margin={[0, 0, 'S']} marginFromM={[0, 0, 'XS']}>
        Get a quick estimate
      </H>
      <P color={COLOR.BLACK} margin={[0, 0, 'L']}>
        Answer a few simple questions to find out how long probate could take
        based on your situation.
      </P>

      {answers.length < QUESTIONS.length ? (
        <Question
          questionIndex={answers.length}
          hasWill={hasWill}
          onAnswer={addAnswer}
          onBack={removeLastAnswer}
        />
      ) : (
        <Result
          estimates={calculateEstimates(answers)}
          notes={getNotes(answers)}
        />
      )}
    </StyledWrapper>
  )
}

export default Calculator
